export default __webpack_public_path__ + "static/media/3012.03ffdc69.jpg";